<template>
  <div class="search-session bg-white">
    <div class="row">
      <div class="col-lg-4 col-md-4 col-sm-6">
        <b-input-group>
          <b-form-input class="placeholder-italic" v-model="textSearch" type="text"
                        placeholder="Search by client or people" :formatter="format"
                        @change="onSearchClients"></b-form-input>
          <Icon name="search" class="search-icon"></Icon>
          <div class="search-icon"></div>
        </b-input-group>
      </div>
    </div>
  </div>
</template>

<script>
  import 'vue-awesome/icons/search';
  import 'vue-awesome/icons/plus-circle';
  import Icon from 'vue-awesome/components/Icon';
  export default {
    name: 'searchSession',
    components: {
      Icon
    },
    props: {
      onSearchText: Function
    },
    data () {
      return {
        textSearch: ''
      };
    },
    methods: {
      onSearchClients () {
        this.onSearchText(this.textSearch);
      }
    }
  };
</script>


// WEBPACK FOOTER //
// SearchSession.vue?2b0cc4dc